import { render, staticRenderFns, recyclableRender, components } from "./header.vue?vue&type=template&id=84be9ac0&scoped=true&"
var renderjs
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"
import style0 from "./header.vue?vue&type=style&index=0&id=84be9ac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84be9ac0",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-calendar/header.vue"
export default component.exports